import { render } from "./WysiwygEditor.vue?vue&type=template&id=baa7e230"
import script from "./WysiwygEditor.vue?vue&type=script&lang=js"
export * from "./WysiwygEditor.vue?vue&type=script&lang=js"

import "./WysiwygEditor.vue?vue&type=style&index=0&id=baa7e230&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__